import _taggedTemplateLiteral from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: block;\n        font-family: inherit;\n        outline: none;\n      }\n    \n      :host(.disabled) {\n        opacity: 0.6 !important;\n        cursor: default;\n        pointer-events: none;\n      }\n    \n      :host(.disabled) svg {\n        background: rgba(0, 0, 0, 0.07);\n      }\n    \n      :host(.pending) {\n        opacity: 0;\n      }\n    \n      :host(:focus) #checkPanel {\n        outline: 3px solid var(--wired-focused-background, rgba(0, 0, 255, 0.2));\n      }\n    \n      #container {\n        display: inline-block;\n        white-space: nowrap;\n      }\n    \n      .inline {\n        display: inline-block;\n        vertical-align: middle;\n      }\n    \n      #checkPanel {\n        cursor: pointer;\n      }\n    \n      svg {\n        display: block;\n      }\n    \n      path {\n        stroke: var(--wired-checkbox-icon-color, currentColor);\n        stroke-width: 0.7;\n      }\n    </style>\n    <div id=\"container\" on-click=\"", "\">\n      <div id=\"checkPanel\" class=\"inline\">\n        <svg id=\"svg\" width=\"0\" height=\"0\"></svg>\n      </div>\n      <div class=\"inline\">", "</div>\n    </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { LitElement, html } from '@polymer/lit-element/lit-element.js';
import { wired } from 'wired-lib/wired-lib.js';
export var WiredCheckbox =
/*#__PURE__*/
function (_LitElement) {
  _inherits(WiredCheckbox, _LitElement);

  _createClass(WiredCheckbox, null, [{
    key: "properties",
    get: function get() {
      return {
        checked: Boolean,
        text: String,
        disabled: Boolean
      };
    }
  }]);

  function WiredCheckbox() {
    var _this;

    _classCallCheck(this, WiredCheckbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WiredCheckbox).call(this));
    _this.disabled = false;
    _this.checked = false;
    return _this;
  }

  _createClass(WiredCheckbox, [{
    key: "_createRoot",
    value: function _createRoot() {
      var root = this.attachShadow({
        mode: 'open'
      });
      this.classList.add('pending');
      return root;
    }
  }, {
    key: "_render",
    value: function _render(_ref) {
      var _this2 = this;

      var text = _ref.text;

      this._onDisableChange();

      return html(_templateObject(), function () {
        return _this2._toggleCheck();
      }, text);
    }
  }, {
    key: "_onDisableChange",
    value: function _onDisableChange() {
      if (this.disabled) {
        this.classList.add("disabled");
      } else {
        this.classList.remove("disabled");
      }

      this._refreshTabIndex();
    }
  }, {
    key: "_refreshTabIndex",
    value: function _refreshTabIndex() {
      this.tabIndex = this.disabled ? -1 : this.getAttribute('tabindex') || 0;
    }
  }, {
    key: "_setAria",
    value: function _setAria() {
      this.setAttribute('role', 'checkbox');
      this.setAttribute('aria-checked', this.checked);
      this.setAttribute('aria-label', this.text);
    }
  }, {
    key: "_toggleCheck",
    value: function _toggleCheck() {
      this.checked = !(this.checked || false);
      var event = new CustomEvent('change', {
        bubbles: true,
        composed: true,
        checked: this.checked,
        detail: {
          checked: this.checked
        }
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_clearNode",
    value: function _clearNode(node) {
      while (node.hasChildNodes()) {
        node.removeChild(node.lastChild);
      }
    }
  }, {
    key: "_didRender",
    value: function _didRender() {
      var svg = this.shadowRoot.getElementById('svg');

      this._clearNode(svg);

      var s = {
        width: 24,
        height: 24
      };
      svg.setAttribute("width", s.width);
      svg.setAttribute("height", s.height);
      wired.rectangle(svg, 0, 0, s.width, s.height);
      var checkpaths = [];
      checkpaths.push(wired.line(svg, s.width * 0.3, s.height * 0.4, s.width * 0.5, s.height * 0.7));
      checkpaths.push(wired.line(svg, s.width * 0.5, s.height * 0.7, s.width + 5, -5));
      checkpaths.forEach(function (d) {
        d.style.strokeWidth = 2.5;
      });

      if (this.checked) {
        checkpaths.forEach(function (d) {
          d.style.display = "";
        });
      } else {
        checkpaths.forEach(function (d) {
          d.style.display = "none";
        });
      }

      this.classList.remove('pending');

      this._setAria();

      this._attachEvents();
    }
  }, {
    key: "_attachEvents",
    value: function _attachEvents() {
      var _this3 = this;

      if (!this._keyboardAttached) {
        this.addEventListener('keydown', function (event) {
          if (event.keyCode === 13 || event.keyCode === 32) {
            event.preventDefault();

            _this3._toggleCheck();
          }
        });
        this._keyboardAttached = true;
      }
    }
  }]);

  return WiredCheckbox;
}(LitElement);
customElements.define('wired-checkbox', WiredCheckbox);